import { render, staticRenderFns } from "./PastNews.vue?vue&type=template&id=1be4f190"
import script from "./PastNews.vue?vue&type=script&lang=js"
export * from "./PastNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports